import { z } from 'zod';

export const LegalDocTypeEnum = z.enum(['terms_of_service', 'meta_ads_policy', 'privacy_policy']);
export type LegalDocType = z.infer<typeof LegalDocTypeEnum>;

export const LegalVersionSchema = z.object({
  docType: LegalDocTypeEnum,
  versionTag: z.string().min(1),
  contentHash: z.string().min(1), // SHA-256 or similar to verify integrity
  pdfUrl: z.string().url(),
  isMajor: z.boolean().default(true), // true if re-acceptance is required
  createdAt: z.any(), // Timestamp
  createdBy: z.string().min(1), // admin user ID
});

export type LegalVersion = z.infer<typeof LegalVersionSchema>;
export type LegalVersionWithId = LegalVersion & { id: string };

export const UserLegalAcceptanceSchema = z.object({
  userId: z.string().min(1),
  docType: LegalDocTypeEnum,
  versionId: z.string().min(1),
  versionTag: z.string().min(1), // Denormalized for easier querying
  acceptedAt: z.any(), // Timestamp
  ipAddress: z.string(),
  userAgent: z.string(),
  metadata: z.record(z.any()).optional(), // e.g., { investmentAmount: 150 } for Meta Ads
});

export type UserLegalAcceptance = z.infer<typeof UserLegalAcceptanceSchema>;
export type UserLegalAcceptanceWithId = UserLegalAcceptance & { id: string };
